import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';

/**
 * Props type for the ReactionConsumer class component
 */

/**
 * State type for the ReactionConsumer class component
 */

/**
 * A custom mapper class that takes the store instance and mapper functions "mapStateToProps" and "mapActionsToProps" to return the renderProps pattern as a child component
 * @deprecated please avoid using this class as it will be removed in a future release
 */
export class ReactionConsumer extends React.PureComponent {
  constructor(props) {
    super(props);
    /**
     * Get the actions the child component might need to dispatch from its props
     */
    _defineProperty(this, "getPropsFromActions", actions => {
      const {
        mapActionsToProps
      } = this.props;
      if (mapActionsToProps) {
        if (!this.previousActions || !this.propsFromActions || this.previousActions !== actions) {
          this.propsFromActions = mapActionsToProps(actions);
        }
      }
      this.previousActions = actions;
      return this.propsFromActions;
    });
    /**
     *
     * @param state Internal state data
     * @returns object containing the data that the connected component needs
     */
    _defineProperty(this, "getPropsFromState", state => {
      const {
        mapStateToProps
      } = this.props;
      return mapStateToProps ? mapStateToProps(state) : undefined;
    });
    /**
     *
     */
    _defineProperty(this, "handleOnChange", () => {
      this.forceUpdate();
    });
    this.state = {
      store: undefined
    };
  }
  componentDidMount() {
    Promise.resolve(this.props.store).then(store => {
      this.setState({
        store
      });
      store.onChange(this.handleOnChange);
    });
  }
  async componentWillUnmount() {
    if (this.state.store) {
      this.state.store.removeOnChangeListener(this.handleOnChange);
    }
  }
  render() {
    if (!this.state.store) {
      return null;
    }
    return this.props.children(Object.assign({}, this.getPropsFromState(this.state.store.getState()), this.getPropsFromActions(this.state.store)));
  }
}